import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CustomerFilter from './customermasters-filter';
import CustomerTable from './customermasters-table';
import CustomerTile from './customermasters-tile';
import CustomerSearch from './customermasters-search';
import { selectCustomerFilterVisible, selectTileView } from './store/selectors'; // Import the selector

const CustomerContent = props => {
  const isFilterVisible = useSelector(selectCustomerFilterVisible); // Use the selector
  const showTileView = useSelector(selectTileView); // Use the selector

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top">
          <CustomerSearch />
        </div>
        {isFilterVisible && <CustomerFilter />}

        {!showTileView ? <CustomerTable /> : <CustomerTile />}
      </div>
    </div>
  );
};

export default CustomerContent;
